import PropTypes from 'prop-types';
import Icon from '../../../assets/images/success-tick.png';
import { Button, ModalComponent } from '../../../common/components';

const SuccessPopup = ({ isOpen, toggle }) => {
  return (
    <ModalComponent isOpen={isOpen} toggle={toggle} className="acc-success-modal-1 lg">
      <div className="acconut-number-modal">
        <div className="save-change-h">Save Changes</div>
        <div className="acconut-number-modal-div my-3">
          <img src={Icon} alt="success-icon" className="mb-3" />
          <div className="acc-number-created j-gl-sus">Changes Saved Successfully</div>
          <Button color="primary" className="atd-btn acc-btn mr-4 my-3" onClick={toggle}>
            Close
          </Button>
        </div>
      </div>
    </ModalComponent>
  );
};

SuccessPopup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};

export default SuccessPopup;
